import moment from "moment";

export class DateFormat {
  static dateRendering = (
    dateVal: Array<Record<string, unknown>>,
    key: "from" | "to"
  ) => {
    switch (key) {
      case "from":
        return moment(dateVal![0]?.$d).startOf("day").format("YYYY-MM-DD");
      case "to":
        return moment(dateVal![1]?.$d)
          .format("YYYY-MM-DD");
    }
  };

  static getDateRange = (dateRange: number = 0) => {
    return {
      fromDate: moment()
        .subtract(dateRange, "day")
        .startOf("day")
        .format("YYYY-MM-DD"),
      toDate: moment().format("YYYY-MM-DD"),
    };
  };
}

export const { dateRendering } = DateFormat;
